<div class="credit-info-container flex flex-column gap-3 mb-5">
  <div>
    <div>
      <span class="title">
        <app-translate key="PAYMENT_INFORMATION"></app-translate>
      </span>
    </div>
    <p-divider></p-divider>
    <div class="past-due-bal-container">
      <div class="hug-text"><app-translate key="PAST_DUE_BALANCE"></app-translate>:</div>
      <div class="title">{{OutStandingBalance | currency}}</div>
    </div>

  </div>
  <div>
    <fieldset class="p-0 border-none">
      <sp-form-wrapper [formGroup]="creditCardOutStandingForm">
        <div>
          <div class="flex mb-4">
            <div class="flex flex-column gap-2 w-full">
              <div class="billing-info"><app-translate key="BILLING_INFORMATION"></app-translate></div>
              <div class="billing-info-body">
                <app-translate key="LAST_NAME_MATCHING_REQUIREMENT"></app-translate>
              </div>
            </div>
          </div>

          <app-credit-card-billing #creditCardOutStandingBalance
            [ServiceAvailabilityZipCode]="ServiceAvailabilityZipCode"
          [PaymentZipMustMatchService]="PaymentZipMustMatchService"></app-credit-card-billing>
          <div class="flex mb-1">
            <div class="flex flex-column gap-2 flex-1">
              <div class="payment-auth mb-1"><app-translate key="PAYMENT_AUTHORIZATION"></app-translate>
            </div>
            <div class="flex align-items-center gap-2">
              <span tabindex="0" class="toc-hyperlink" (click)="paymentAuthorizationDialog = true"
                (keydown.enter)="paymentAuthorizationDialog = true">
                <app-translate key="READ_TERMS_CONDITIONS"></app-translate>
              </span>
              <i class="pi pi-open cursor-pointer" tabindex="0"
                (click)="paymentAuthorizationDialog = true"
                (keydown.enter)="paymentAuthorizationDialog = true">
              </i>
            </div>
            <div class="mt-2 sub-heading"><app-translate
            key="CUSTOMER_BILLING_CALL_INFO"></app-translate></div>

          </div>
        </div>

        <div class="flex gap-2 align-items-center ml-2 mt-4 justify-content-start">
          <p-checkbox inputId="isConsentAgreed" [binary]="true" formControlName="isConsentAgreed" />
          <label for="isConsentAgreed" class="ml-2" class="sub-title">
            <app-translate key="AGREE_PAYMENT_TERMS"></app-translate>
          </label>
        </div>
        @if (creditCardOutStandingForm.get('isConsentAgreed')?.invalid && creditCardOutStandingForm.get('isConsentAgreed')?.touched) {
          <div class="flex ml-2"
            >
            <small class="p-error"><app-translate key="MUST_AGREE_PAYMENT_TERMS"></app-translate></small>
          </div>
        }


      </div>
    </sp-form-wrapper>

  </fieldset>

</div>
<div class="mt-4">
  <div class="mb-3 button-label">
    <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onFormSubmit()" class="button-label"
      styleClass="p-button-lg w-full p-button-radius p-button-primary" />
  </div>
  <div class="mb-1">
    <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
      (onClick)="onFormCancel()" />
  </div>
</div>

<div class="sub-title"><app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
</div>
</div>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancelPopUp($event)"></app-confirm-popup>


<p-dialog [(visible)]="paymentAuthorizationDialog"
  [header]="languageService.getTranslation('PAYMENT_AUTHORIZATION_TERMS')"
  [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="border-round-3xl" appendTo="body" [modal]="true"
  [blockScroll]="true" [closeOnEscape]="false">
  <div class="terms-content max-h-70vh overflow-y-auto">
    <div>
      <h4><app-translate key="PARTIES"></app-translate></h4>
      <p><app-translate key="PARTIES_DESCRIPTION"></app-translate></p>

      <h4><app-translate key="ONE_TIME_PAYMENT_AUTH"></app-translate></h4>
      <p><app-translate key="ONE_TIME_PAYMENT_AUTH_DESCRIPTION"></app-translate></p>

      <h4><app-translate key="PAYMENT_METHOD"></app-translate></h4>
      <p><app-translate key="PAYMENT_METHOD_DESCRIPTION"></app-translate></p>

      <h4><app-translate key="REVOCATION"></app-translate></h4>
      <p><app-translate key="REVOCATION_DESCRIPTION"></app-translate></p>

      <h4><app-translate key="GENERAL"></app-translate></h4>
      <p><app-translate key="GENERAL_DESCRIPTION"></app-translate></p>
    </div>
  </div>
  <div class="flex flex-1 gap-3 justify-content-end">
    <p-button [label]="languageService.getTranslation('CLOSE')" [link]="true" styleClass="button"
      (click)="paymentAuthorizationDialog = false" />
  </div>
</p-dialog>